/**
 * The one way a D365 code and its name read in a dropdown: `CODE — Name`.
 *
 * D365 often has no separate name, or repeats the code as the name (`35-INV-CPX-General` named
 * `35-INV-CPX-General`), or builds the name from the code (`99-Default` / `99-Default (Expense)`).
 * Printing both then reads as a stutter, so the code is shown once in those cases.
 */
export function codeLabel(code: string, name: string | null | undefined): string {
  const trimmedName = (name ?? '').trim();
  if (trimmedName === '' || trimmedName === code) return code;
  if (trimmedName.startsWith(code)) return trimmedName;
  return `${code} — ${trimmedName}`;
}
